import React from 'react';
interface GiadaAvatarProps {
  size?: 'small' | 'medium' | 'large';
  showName?: boolean;
}
export const GiadaAvatar: React.FC<GiadaAvatarProps> = ({
  size = 'medium',
  showName = false
}) => {
  const sizeMap = {
    small: 24,
    medium: 40,
    large: 64
  };
  const pixelSize = sizeMap[size];
  return <div className="flex items-center gap-2" data-id="element-205">
      <div className="rounded-full p-[3px] flex-shrink-0" style={{
      background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 50%, rgba(116, 10, 214, 1) 100%)'
    }} data-id="element-206">
        <div className="rounded-full bg-white overflow-hidden" style={{
        width: `${pixelSize}px`,
        height: `${pixelSize}px`
      }} data-id="element-207">
          <img src="https://cdn.magicpatterns.com/uploads/aCtX85FjB2uZdgukeFfHrY/ChatGPT_Image_Jan_2,_2026,_12_13_55_PM.png" alt="Giada AI" className="w-full h-full object-cover" data-id="element-208" />
        </div>
      </div>
      {showName && <span className="font-medium text-gray-900" data-id="element-209">Giada AI</span>}
    </div>;
};